import { useEffect, useState } from 'react';
import { getAccessToken } from '../lib/auth';

export interface FxRates {
  /** 1 GBP = unitsPerGbp[ccy] of the currency, e.g. { GBP: 1, USD: 1.34 }. */
  unitsPerGbp: Record<string, number>;
}

/**
 * Rates from /api/fx (the shared crbb7_fxrate table). Used for the display
 * currency toggle — placements arrive denominated in the viewer's own
 * currency, and this converts them for display only. Returns null until
 * loaded; if the fetch fails the toggle simply stays hidden.
 */
export function useFx(): FxRates | null {
  const [rates, setRates] = useState<FxRates | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await getAccessToken();
        if (!token) return;
        const res = await fetch('/api/fx', { headers: { 'X-User-Token': token } });
        if (!res.ok) return;
        const body = (await res.json()) as { unitsPerGbp?: Record<string, number> };
        if (!cancelled && body.unitsPerGbp) setRates({ unitsPerGbp: body.unitsPerGbp });
      } catch {
        // No rates → no currency toggle; the viewer's own currency still works.
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return rates;
}
